;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function AcademyDigital() {
  return (
    <svg width="129" height="124" viewBox="0 0 129 124" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M120.368 32.5597H125.897L127.05 30.256C127.494 29.369 127.614 28.354 127.389 27.3875C127.164 26.421 126.607 25.5643 125.817 24.9665L96.5445 2.80113C95.398 2.11137 94.0434 1.85516 92.725 2.07873H53.2473C52.6497 2.07843 52.0639 2.24496 51.5554 2.5597C51.047 2.87443 50.636 3.32492 50.3687 3.86064C50.0279 4.54092 49.938 5.32008 50.115 6.06037C50.2919 6.80065 50.7242 7.45438 51.3355 7.90602L83.3325 31.5303C84.4889 32.2544 85.8356 32.6138 87.198 32.5617H114.841"
        stroke="#64348C"
        strokeWidth="3"
      />
      <path
        d="M91.4252 14.7144L112.076 29.7883C113.623 30.8418 114.84 34.522 114.84 38.1018V60.2713"
        stroke="#A7DADB"
        strokeWidth="3"
      />
      <path
        d="M65.51 19.2598L60.4574 34.5103C59.2163 38.2547 67.2956 44.3148 78.5058 48.0451C89.7159 51.7755 99.8051 51.7634 101.046 48.017L106.099 32.7665"
        stroke="#64348C"
        strokeWidth="3"
      />
      <path
        d="M101.018 49.1764V101.827C101.018 102.562 100.727 103.267 100.208 103.786C99.69 104.306 98.9868 104.598 98.2536 104.598H4.26451C3.53304 104.598 2.8314 104.307 2.31324 103.79C1.79508 103.272 1.50265 102.57 1.5 101.837V38.1017C1.5 37.3668 1.79126 36.6619 2.3097 36.1422C2.82815 35.6225 3.53131 35.3306 4.26451 35.3306H59.5526"
        stroke="#64348C"
        strokeWidth="3"
      />
      <path d="M39.5344 122V109.96" stroke="#64348C" strokeWidth="3" />
      <path d="M61.5544 109.96V122" stroke="#64348C" strokeWidth="3" />
      <path d="M75.5671 122H25.5217" stroke="#64348C" strokeWidth="3" />
      <path d="M1.5 87.8872H101.591" stroke="#64348C" strokeWidth="3" />
    </svg>
  );
}
